<template>
	<div class="test-question">
		<div class="ortho-bold test-position-question">
			<span>{{ testTrack.question }}</span>
		</div>
		<div v-if="testTrack && testTrack.instruction" class="test-position-action-container">
			<p>{{ testTrack.instruction }}</p>
		</div>
		<div class="test-position-answers-container">
			<FadeTransition group>
				<div
					class="hvr-bounce-in test-position-answers"
					:class="{ 'answer-disabled': isProcessing }"
					v-for="(answer, index) in testTrack.answers"
					:key="index"
					@click="!isProcessing && onClickAnswer(answer)"
				>
					{{ answer.answer }}<br />
				</div>
			</FadeTransition>
		</div>
	</div>
</template>

<script>
import { FadeTransition } from 'vue2-transitions';

export default {
	name: 'QuestionQCM',
	/**
	 * @changed_at 29/04/2026 by AI (claude-sonnet-4-5)
	 */
	props: {
		testTrack: Object,
		onClickAnswer: Function,
		isProcessing: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		FadeTransition,
	},
};
</script>

<style lang="scss" scoped>
// Style in styles.css
.answer-disabled {
	opacity: 0.5;
	cursor: not-allowed;
	pointer-events: none;
}
</style>
